/**
 * Who can receive inbox items: a person in the account through a direct membership. A master account
 * member's session never gets one, so it never polls for them.
 */
import type { MembershipSource as MembershipSourceValue } from '@/graphql';
import { MembershipSource } from '@/features/auth/constants/membership-source';

export function canReceiveInbox(
  user: { source?: MembershipSourceValue | null } | null | undefined
): boolean {
  return user != null && user.source !== MembershipSource.MASTER_ACCOUNT;
}
